import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
// Import Images
import multiUser from '../../assets/images/users/multi-user.jpg';

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  ModalBody,
  Label,
  Input,
  Modal,
  ModalHeader,
  Form,
  ModalFooter,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormFeedback
} from "reactstrap";
import TableContainer from "../../Components/Common/TableContainer"; 
import Select from "react-select";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";

//Import actions 
import {  selectAvatar } from '../../utils/usermanagement';

import { getEmployeesList,addEmployees,getMnagerListByOEMId,updateEmployee,deleteEmployee,baseURL} from '../../utils/employees';
import { getOEMList } from '../../utils/calender';
import {addEmployeeProfileImage} from '../../utils/imageapi';
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AvatarSelector from '../Authentication/Profile/Avatar';
// Export Modal
import ExportCSVModal from "../../Components/Common/ExportCSVModal"; 
import { getNfcByUid,nfcAll,nfcAdd,userNfcUpdate } from "../../utils/nfc";

const Employees = () => {   
  // Inside your component 
  const [isEdit, setIsEdit] = useState(false);
  const [isInfo, setIsInfo] = useState(false);
  const [user, setUser] = useState([]);
  const [userRole,setUserRole]=useState(null);
  const [nfcEdit,setNfcEdit]=useState(false);
  const [selectCompanyId, setSelectCompanyId] = useState("");
  const [isEditCompany,setIsEditCompany] = useState(false);
  //delete user
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [selectedAddressCity, setAddressCity] = useState(null);
  const [selectedState, setAddressState] = useState(null);
  const [selectedAddressCountry, setAddressCountry] = useState(null);

  const [modal, setModal] = useState(false);
  const [OEMOptions, setOEMOptions] = useState([]);
  const [userList, setUserList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [nfcId, setNfcId] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [mainImageUrl, setMainImageUrl] = useState(""); 
  const [avatarUrl, setAvatarUrl] = useState(null); // Store uploaded avatar URL
  const [manageShow, setManageShow] = useState(false);
  const [showAvatarModal, setShowAvatarModal] = useState(false);
  const  [managerList, setManagerList] = useState([]);
  const productState = [
    {
        options: [
        { label: "Select State...", value: "Select State" },
        { label: "Alabama", value: "Alabama" },
        { label: "Alaska", value: "Alaska" },
        { label: "American Samoa", value: "American Samoa" },
        { label: "California", value: "California" },
        { label: "Colorado", value: "Colorado" },
        { label: "District Of Columbia", value: "District Of Columbia" },
        { label: "Florida", value: "Florida" },
        { label: "Georgia", value: "Georgia" },
        { label: "Guam", value: "Guam" },
        { label: "Hawaii", value: "Hawaii" },
        { label: "Idaho", value: "Idaho" },
        { label: "Kansas", value: "Kansas" },
        { label: "Louisiana", value: "Louisiana" },
        { label: "Montana", value: "Montana" },
        { label: "Nevada", value: "Nevada" },
        { label: "New Jersey", value: "New Jersey" },
        { label: "New Mexico", value: "New Mexico" },
        { label: "New York", value: "New York" },
        ],
    },
    ];
    
    const productCountry = [
    {
        options: [
        { label: "Select Country...", value: "Select Country" },
        { label: "United States", value: "United States" },
        ],
    },
    ];
  // Define toggle function with useCallback to prevent recreation on every render
// CSS for the avatar modal
const avatarModalStyles = `
  .avatar-modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 2000;
  }

  .avatar-modal {
      background-color: white;
      border-radius: 10px;
      width: 90%;
      max-width: 900px;
      max-height: 90vh;
      overflow: hidden;
      z-index: 2000;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      display: flex;
      flex-direction: column;
  }

  .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      background-color: #2dd4bf;
      color: white;
  }

  .modal-header h3 {
      margin: 0;
      font-size: 20px;
  }

  .close-btn {
      background: none;
      border: none;
      color: white;
      font-size: 24px;
      cursor: pointer;
      line-height: 1;
  }
  `;
  const toggle_modal = useCallback(() => {
      if (modal) {
        setModal(false);
        
        setAddressCity(null);
        setAddressCountry(null);
        setAddressState(null);
        loadUserList(currentPage, pageSize);
      } else {
        setModal(true);
      }
    }, [modal]);    
  function handleSelectAddressCity(value) {  
      setAddressCity(value);
  } 
  
  function handleSelectState(value) {
      setAddressState(value); 
  }
  
  function handleSelectAddressCountry(value) {  
      setAddressCountry(value);
  }

  function handleChangeCompanyId (value) {
      setSelectCompanyId(value);
  }
  // Add pagination handler
  const handlePageChange = async (params) => {
     
    try {
      // Add null check and proper parameter names
      const page = params?.pageIndex || 1;
      const pageSize = params?.pageSize || 10;
      
      console.log('=== handlePageChange Debug ===');
      console.log('Full params object:', params);
      console.log('params keys:', Object.keys(params || {}));
      console.log('params values:', Object.values(params || {}));
      console.log('params.searchTerm:', params?.searchTerm);
      console.log('params.search:', params?.search);
      console.log('params.query:', params?.query);
      console.log('params.filter:', params?.filter);
      console.log('params.globalFilter:', params?.globalFilter);
      
      const searchTerm = params?.searchTerm || params?.search || params?.query || params?.globalFilter || '';
      
      console.log('Extracted search term:', searchTerm);
      
      const param={
        page:page,
        per_page:pageSize
      }
      
      // Add search term if provided
      if (searchTerm && searchTerm.trim()) {
        param.ilike = searchTerm.trim();
        console.log('Added ilike parameter:', param.ilike);
      } else {
        console.log('No search term found, ilike not added');
      }
      
      console.log('Final request params:', param);
      console.log('=== End Debug ===');
      
      const response = await getEmployeesList(param);
      if(response.status === 200) {
        setTotal(response.data.total);
        setUserList(response.data.employees);  
        // setAddressCity(response.data.profile.users.city);
        // setAddressCountry(response.data.profile.users.country);
        // setAddressState(response.data.profile.users.state);
        setCurrentPage(page);
        setPageSize(pageSize);
      }
    } catch (error) {
       
      toast.error(error.message);
    }
  };
  
    // Handle avatar selection from the modal
    const handleAvatarSelect = async (avatarId,petId) => { 
      setUser((prevData) => ({
        ...validation.values,
        avatar_filename: avatarId,
        pet_filename: petId,
     })); 
     setAvatarUrl( avatarId ? `${baseURL}/file/avatar/${avatarId}` :null); 
      setShowAvatarModal(false); // Close the modal after selection
      
  };
  const loadOemList = async () => {
    try {
      const response = await getOEMList({page:1,per_page:1000});
        
      if(response.status === 200){ 
          setOEMOptions(response.data.data);  
      } else {
         
        toast.error(response.message, { autoClose: 3000 });  
      }
    } catch (error) {
       
      toast.error(error.message, { autoClose: 3000 }); 
    }
  };
  
  const loadUserList = async (page = currentPage, size = pageSize) => {
    try {  
      const param={
        page:page,
        per_page:size
      }
      const response = await getEmployeesList(param);   
      if(response.status === 200){ 
        console.log( response.data.employees);
        setTotal(response.data.total);
        setUserList(response.data.employees);  
      }
    } catch (error) {
       
      toast.error(error.message, { autoClose: 3000 }); 
    }
  };

  useEffect(() => { 
    const userData = JSON.parse(sessionStorage.getItem("user"));
    const role = userData.role;
    setUserRole(role);
    if(role === "employee3"||role === "employee2"){
      setSelectCompanyId(userData.company_id);
      setIsEditCompany(false);
    }else if(role === "superadmin"){
      setIsEditCompany(true);
    }
    loadUserList(1, 10);
    loadOemList();
  }, []); 
  
  useEffect(() => {
    setUser(userList);
  }, [userList]);

  useEffect(() => {
    if (!isEmpty(userList)) {
      setUser(userList);
      setIsEdit(false);
    }
  }, [userList]);


  // Delete Data
  const handleDeleteuser = async () => {
    if (user && user._id) {
     try {
       const response = await deleteEmployee(user._id);
       if(response.status === 200){ 
        toast.success("User Delete Successfully", { autoClose: 3000 });  
         loadUserList(currentPage, pageSize);
       } else {
         
        toast.error(response.message, { autoClose: 3000 }); 
       }
     } catch (error) {
       
      toast.error(error.message, { autoClose: 3000 }); 
     }  
      setDeleteModal(false);
    }
  };
  function handleNFCIDChange(value) {  
    setNfcId(value);
}

  const onClickDelete = (user) => {
    setUser(user);
    setDeleteModal(true);
  };
 
  const handleChangeRole = (e) => {  

    const userData = JSON.parse(sessionStorage.getItem("user")) ;
    debugger
    const newRole = e.target.value; 
    validation.setFieldValue('parent_id', ''); 
    validation.values.parent_id = "";  
    if(e.target.value === "employee1"){ 
      setUser(prev => ({
        ...prev,
        ...validation.values,
        role: newRole, 
        parent_id: ""
      })); 
      fenchManagerList("employee2");
      setManageShow(true);
    }else if(e.target.value=="employee2"||e.target.value=="employee3"){
      
      setManagerList([{id:userData.id,first_name:userData.name}]);
      setUser(prev => ({
        ...prev,
        ...validation.values,
        role: newRole,
        parent_id: userData.id
      })); 
      setManageShow(false);
    }
  };
  const fenchManagerList = async (role) => {
    try {  
      const userData = JSON.parse(sessionStorage.getItem("user")) ;
      const response = await getMnagerListByOEMId(userData.company_id,role);
      if(response.status === 200){
        setManagerList(response.data.employees, { autoClose: 3000 });
       
      } else {
        toast.error(response.message, { autoClose: 3000 });
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
    }
  };
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: (user && user.first_name) || '',
      last_name: (user && user.last_name) || '',
      email: (user && user.email) || '',
      role: (user && user.role) || '',
      phone: (user && user.phone) || '', 
      street_address: (user && user.street_address) || '',
      position: (user && user.position) || '',
      department: (user && user.department) || '',
      seedpower_points: (user && user.seedpower_points) || '',
      oem_id: (user && user.oem_id) || '', 
      parent_id: (user && user.parent_id) || '',
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("Please Enter user Name"),
      last_name: Yup.string().required("Please Enter last_name name"),
      email: Yup.string().required("Please Enter Contact Email"),
      role: Yup.string().required("Please Enter role"), 
      phone: Yup.string().required("Please Enter Phone"),
      parent_id: Yup.string().required("Please select Manager"),
      street_address: Yup.string().required("Please Enter Address"),
      position: Yup.string().required("Please Enter Position"),
      department: Yup.string().required("Please Enter Department"),
      seedpower_points: Yup.string().required("Please Enter Rating"),  
      
    }),
  });

  const handleSubmit = async (values) => {
    await validation.validateForm();
    if (!validation.isValid) {
      debugger
        toast.error("请填写所有必填字段");
        return;
    }
    if (isEdit) {
      debugger
      const updateuser = {
        ...user,  // 保留所有现有的用户信息
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        role: values.role,
        oem_id: selectCompanyId,
        phone: values.phone,
        street_address: values.street_address,
        position: values.position,
        department: values.department,
        location: {
          city: selectedAddressCity,
          country: selectedAddressCountry,
          state: selectedState,
        },
        parent_id: values.parent_id,
        seedpower_points: values.seedpower_points,
        avatar_filename: user?.avatar_filename || null,
        pet_filename: user?.pet_filename || null,
      };
      
      try { 
        const response = await updateEmployee(updateuser.id, updateuser);   
 
        if(response.status === 200){  
           toast.success(response.data.message);   
          if(!isEmpty(nfcId) && nfcId!=null){
            if(user.nfc_tag){
              updateNfcId(user.nfc_tag.uid); 
            }else{
              addNfcId(response.data.employee.id);
            } 
          }else{
            toast.error("Please Scan NFC Tag");
          }
        } else {
          toast.error(response.response.data.message); 
        }
      } catch (error) {
        toast.error(error); 
      }  
    } else {
      const newuser = {
        id: (Math.floor(Math.random() * (30 - 20)) + 20).toString(), 
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        role: values.role,
        oem_id: selectCompanyId,
        phone: values.phone,
        street_address: values.street_address,
        position: values.position,
        parent_id: values.parent_id,
        department: values.department,
        location: {
          city: selectedAddressCity,
          country: selectedAddressCountry,
          state: selectedState,
        },
        seedpower_points: values.seedpower_points,
        avatar_filename: user? user.avatar_filename : null,
        pet_filename: user? user.pet_filename : null,
      };
      
      try { 
        const response = await addEmployees(newuser);   
         
        if(response.status === 200 || response.status === 201){   
           
          addNfcId(response.data.employee.id); 
        } else {
          toast.error(response.response.data.message); 
        }
      } catch (error) {
        toast.error(error); 
      }  
      validation.resetForm();
    }
  };

  const handleInfo = useCallback((arg) => {
    const user = arg;  
    setUser({ 
      id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      role: user.role,
      oem_id: user.oem_id,
      phone: user.phone,
      street_address: user.street_address,
      position: user.position,
      department: user.department,
      seedpower_points: user.seedpower_points,
      country: user.location.country,
      state: user.location.state,
      city: user.location.city,
      parent_id: user.parents[0],
      avatar_filename: user.profile_photo_url_object.profile_url,
      nfc_tag: user.nfc_tag,
      pet_filename: user.profile_photo_url_object.pet_url,
    });
    setNfcId(null);
    setAddressCity(user.location.city);
    setAddressCountry(user.location.country);
    setAddressState(user.location.state);
    if(user.nfc_tag){
      setNfcId(user.nfc_tag.uid);
    }   
    setAvatarUrl(
     user.profile_photo_url_object.profile_url
           ? `${baseURL}/file/avatar/${user.profile_photo_url_object.profile_url}`
            : null
    );
    setIsInfo(true);
    setIsEdit(true);
    toggle_modal();
  });
  // Update Data
  const handleuserClick = useCallback((arg) => {
     debugger
    const user = arg;  
    setUser({
      id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      role: user.role,
      oem_id: user.oem_id,
      phone: user.phone,
      street_address: user.street_address,
      position: user.position,
      department: user.department,
      seedpower_points: user.seedpower_points,
      country: user.location.country,
      state: user.location.state,
      city: user.location.city,
      parent_id: user.parents[0],
      avatar_filename: user.profile_photo_url_object.profile_url,
      nfc_tag: user.nfc_tag,
      pet_filename: user.profile_photo_url_object.pet_url,
    });
    setIsInfo(false);
    setIsEdit(true);
    setNfcId(null);
    setAddressCity(user.location.city);
    setAddressCountry(user.location.country);
    setAddressState(user.location.state);
    if(user.nfc_tag){
      setNfcId(user.nfc_tag.uid);
    }   
    if(user.role === "employee1"){
      fenchManagerList("employee2");
      setManageShow(true);
    }else if(user.role=="employee2"){
      fenchManagerList("employee3");
      setManageShow(false);
    }else if(user.role=="employee3"){  
      setManageShow(false);
    }
     setAvatarUrl(
      user.profile_photo_url_object.profile_url
            ? `${baseURL}/file/avatar/${user.profile_photo_url_object.profile_url}`
             : null
     );
    toggle_modal();
  });  
const updateNfcId = async (old_uid) => {
  try { 
    const response = await userNfcUpdate(nfcId,old_uid);
     
    if(response.status === 200){
      toast.success(response.data.message); 
     setNfcId(response.data.data.uid); 
     toggle_modal();
     loadUserList(currentPage, pageSize);
     
    }
    else {
      toast.error(response.response.data.message);
    }
  }
  catch (error) {
    console.error('Error fetching NFC data:', error); 
  }
}
const addNfcId = async (uid) => {
  try {
    const param={
      tag_type:"user",
      assigned_id:uid,
      uid:nfcId, 
    }
    const response = await nfcAdd(param); 
    if(response.status === 200){
      toast.success(response.data.message); 
     setNfcId(response.data.data.uid); 
     toggle_modal();
     loadUserList(currentPage, pageSize);
     
    }
    else {
      toast.error(response.response.data.message);
    }
  }
  catch (error) {
    console.error('Error fetching NFC data:', error); 
  }
}


  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".userCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  const deleteMultiple = async () => {
    const checkall = document.getElementById("checkBoxAll");
    for (const element of selectedCheckBoxDelete) {
      try {
        await deleteUser(element.value);
      } catch (error) {
        toast.error(error.message); 
      }
    }
    
    loadUserList(currentPage, pageSize);
    setIsMultiDeleteButton(false);
    checkall.checked = false;
    toast.success("Selected users deleted successfully");
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".userCheckBox:checked");
    ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        header: <input type="checkbox" className="form-check-input" id="checkBoxAll" onClick={() => checkedAll()} />,
        cell: (cell) => {
          return <input type="checkbox" className="userCheckBox form-check-input" value={cell.getValue()} onChange={() => deleteCheckbox()} />;
        },
        id: 'id',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "First Name",
        accessorKey: "first_name",
        enableColumnFilter: false,
        cell: (cell) => (
            <>
            <div className="d-flex align-items-center"> 
                <Link to={"/employees-detail?userId="+cell.row.original.id} className="currency_name flex-grow-1 ms-2">{cell.getValue()}</Link>
            </div>
        </>
        ),
      },
      {
          header: "Last Name",
          accessorKey: "last_name",
          enableColumnFilter: false,
          
      },
      {
          header: "NFC ID",
          accessorKey: "nfc_tag.uid",
          enableColumnFilter: false, 
      }, 
      {
          header: "Email",
          accessorKey: "email",
          enableColumnFilter: false,
           
      }, 
      {
          header: "Company",
          accessorKey: "company.oem_brandname",
          enableColumnFilter: false, 
      },
      {
          header: "Department",
          accessorKey: "department",
          enableColumnFilter: false, 
      },
      {
          header: "Position",
          accessorKey: "position",
          enableColumnFilter: false, 
      },
      {
          header: "Seedpower Points",
          accessorKey: "seedpower_points",
          enableColumnFilter: false, 
      },
      {
          header: "Role",
          accessorKey: "role",
          enableColumnFilter: false, 
      }, 
      {
        header: "Action",
        cell: (cell) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0"> 
              <li className="list-inline-item" title="View">
                <Link  className="edit-item-btn" to="#" onClick={() => { const userData = cell.row.original; handleInfo(userData); }} 
                >
                  <i className="ri-eye-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Edit">
                <Link className="edit-item-btn" to="#"
                  onClick={() => { const userData = cell.row.original; handleuserClick(userData); }}
                >
                  <i className="ri-pencil-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Delete">
                <Link
                  className="remove-item-btn"
                  onClick={() => { const userData = cell.row.original; onClickDelete(userData); }}
                  to="#"
                >
                  <i className="ri-delete-bin-fill align-bottom text-muted"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleuserClick, handleInfo, checkedAll]
  );
 
  // Export Modal
  const [isExportCSV, setIsExportCSV] = useState(false);

  document.title = "Employees | SeedNations";
  return (
    <React.Fragment>
        <ToastContainer 
          position="top-center"
          autoClose={3000}
          style={{ zIndex: 99999 }}  // 设置更高的层级
          theme="colored"
        />
      <div className="page-content">
                    
        <ExportCSVModal
          show={isExportCSV}
          onCloseClick={() => setIsExportCSV(false)}
          data={userList}
        />

        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteuser}
          onCloseClick={() => setDeleteModal(false)}
        />

        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid> 
          <BreadCrumb title="Employee LIST" pageTitle="CRM" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <div className="flex-grow-1">
                      <button className="btn btn-primary add-btn" onClick={() => { setIsEdit(false); setIsInfo(false); toggle_modal(); setNfcEdit(true)}}>
                        <i className="ri-add-fill me-1 align-bottom"></i> Add Employee
                      </button>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="hstack text-nowrap gap-2">
                        {isMultiDeleteButton && <button className="btn btn-soft-danger"
                          onClick={() => setDeleteModalMulti(true)}
                        ><i className="ri-delete-bin-2-line"></i></button>}
                        {(userRole === "superadmin" || userRole === "employee3") && (
                          <Link to="/employees-search" className="btn btn-soft-info">
                            <i className="ri-search-line me-1 align-bottom"></i>
                            Search Employees
                          </Link>
                        )}
                        <button className="btn btn-soft-primary">
                          <i className="ri-filter-2-line me-1 align-bottom"></i>{" "}
                          Filters
                        </button>
                        <button className="btn btn-soft-success" onClick={() => setIsExportCSV(true)}>Export</button>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            href="#"
                            className="btn btn-soft-danger"
                            tag="button"
                            type="button"
                          >
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem className="dropdown-item" href="#">
                              All
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Week
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Month
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Year
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={12}>
              <Card id="userList">
                <CardBody className="pt-0">
                  <div>
                    {userList?.length ? (
                      <TableContainer
                        columns={columns}
                        data={(userList || [])}
                        total={total}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        onChange={handlePageChange}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={10}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-2"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                        handleuserClick={handleuserClick} 
                        isUserListFilter={true}
                        SearchPlaceholder='Search for employees...'
                      />
                    ) : ""}
                  </div>
                  <Modal id="showModal" isOpen={modal} toggle={toggle_modal} centered size="lg">
                    <ModalHeader className="bg-info-subtle p-3"   >
                      {!!isInfo ? "User Info" : !!isEdit ? "Edit Employee" : "Add Employee"}
                    </ModalHeader>
                    <Form className="tablelist-form" onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit(validation.values);
                      return false;
                    }}>
                      <ModalBody>
                        <input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={12}>
                          <div className="text-center">
                              <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                                  <img 
                                      src={avatarUrl?avatarUrl:multiUser}
                                      className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                      alt="user-profile" 
                                  />
                                  <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                                      <Label 
                                          htmlFor="profile-img-file-input"
                                          className="profile-photo-edit avatar-xs"
                                      >
                                          <span className="avatar-title rounded-circle bg-light text-body">
                                                   {isInfo?"":  <i 
                                                    className="ri-camera-fill" 
                                                    onClick={() => setShowAvatarModal(true)}
                                                    style={{ cursor: 'pointer' }}
                                                ></i> }
                                          </span>
                                      </Label>
                                  </div>
                              </div>
                              <h5 className="fs-13 mt-3">user Logo</h5>
                            </div>
                          </Col>

                          <Col lg={12}>
                            <div>
                              <Label
                                htmlFor="name-field"
                                className="form-label"
                              >
                                First Name
                              </Label>

                              <Input
                                name="first_name"
                                id="customername-field"
                                className="form-control"
                                placeholder="Enter user Name"
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                readOnly={isInfo}
                                disabled={isInfo}
                                onBlur={validation.handleBlur}
                                value={validation.values.first_name || ""}
                                invalid={ validation.errors.first_name ? true : false
                                }
                              />
                              {validation.errors.first_name ? (
                                <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="last_name-field"
                                className="form-label"
                              >
                                Last Name
                              </Label>
                              <Input
                                name="last_name"
                                id="last_name-field"
                                className="form-control"
                                placeholder="Enter last_name Name"
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.last_name || ""}
                                invalid={validation.errors.last_name ? true : false
                                }
                              />
                              {validation.errors.last_name ? (
                                <FormFeedback type="invalid">{validation.errors.last_name}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="oem-id-field"
                                className="form-label"
                              >
                              company
                              </Label>

                              {isEditCompany?<Input
                                name="oem_id"
                                type="select"
                                className="form-select"
                                id="oem-id-field"
                                onChange={handleChangeCompanyId}
                                onBlur={validation.handleBlur}
                                readOnly={isInfo}
                                disabled={isInfo}
                                value={selectCompanyId}
                              >
                                <option value="">Select Company</option>
                                {OEMOptions.map((item, key) => (
                                  <React.Fragment key={key}>
                                    <option value={item.id} key={key}>{item.oem_companyname}</option>
                                  </React.Fragment>
                                ))}
                              </Input> :<div className="mt-2">
                                {OEMOptions.find(item => item.id === selectCompanyId)?.oem_companyname || ''}
                              </div>}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="country-field"
                                className="form-label"
                              >
                                NFC ID
                              </Label>
                              <Input
                                name="NFC_ID"
                                id="NFC-ID-field"
                                className="form-control"
                                placeholder="Enter NFC ID"
                                type="text"
                                readOnly={isInfo}  // 修改这里
                                disabled={isInfo}
                                onChange={(e) => {
                                  handleNFCIDChange(e.target.value);
                                }}
                                onBlur={validation.handleBlur}
                                value={nfcId || ""}
                                invalid={validation.errors.nfcId? true : false
                                }
                              />
                              {validation.errors.nfcId? (
                                <FormFeedback type="invalid">{validation.errors.nfcId}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="email-field"
                                className="form-label"
                              >
                                address
                              </Label>
                              <Input
                                name="street_address"
                                id="street-address-field"
                                className="form-control"
                                placeholder="Enter street address"
                                type="text"
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.street_address || ""}
                                invalid={validation.errors.street_address? true : false 
                                }
                              />
                              {validation.errors.street_address? (
                                <FormFeedback type="invalid">{validation.errors.street_address}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="position-field"
                                className="form-label"
                              >
                                position
                              </Label>
                              <Input
                                name="position"
                                id="position-field"
                                className="form-control"
                                placeholder="Enter position"
                                type="text"
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.position || ""}
                                invalid={validation.errors.position? true : false
                                }
                              />
                              {validation.errors.position? (
                                <FormFeedback type="invalid">{validation.errors.position}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="department-field"
                                className="form-label"
                              >
                                department
                              </Label>
                              <Input
                                name="department"
                                id="department-field"
                                className="form-control"
                                placeholder="Enter department"
                                type="text"
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.department || ""}
                                invalid={validation.errors.department? true : false 
                                }
                              />
                              {validation.errors.department? (
                                <FormFeedback type="invalid">{validation.errors.department}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="seedpower_points-field"
                                className="form-label"
                              >
                                SeedPower Points
                              </Label>
                              <Input
                                name="seedpower_points"
                                id="seedpower_point-field"
                                className="form-control"
                                placeholder="Enter seedpower_points"
                                type="text"
                                readOnly={isInfo}
                                disabled={isInfo}
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.seedpower_points || ""}
                                invalid={validation.errors.seedpower_points ? true : false
                                }
                              />
                              {validation.errors.seedpower_points ? (
                                <FormFeedback type="invalid">{validation.errors.seedpower_points}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div>
                              <Label
                                htmlFor="role-field"
                                className="form-label"
                              >
                                Role
                              </Label>
                              <Input
                                name="role"
                                id="role-field"
                                className="form-control"
                                type="select"
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={handleChangeRole}
                                onBlur={validation.handleBlur}
                                value={validation.values.role || ""}
                                invalid={ validation.errors.role ? true : false
                                }
                              >
                                <option value="">Select Role</option> 
                                <option value="employee1">Employee 1</option>
                                <option value="employee2">Employee 2</option> 
                                {userRole=="superadmin"||user.role=="employee3"?<option value="employee3">Employee 3</option> :null}
                              </Input>
                              {validation.errors.role ? (
                                <FormFeedback type="invalid">{validation.errors.role}</FormFeedback>
                              ) : null}

                            </div>
                          </Col> 
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="parent_id-field"
                                className="form-label"
                              >
                                manager
                              </Label>
                              <Input
                                name="parent_id"
                                id="parent_id-field"
                                className="form-control"
                                type="select"
                                readOnly={isInfo||!manageShow}
                                disabled={isInfo||!manageShow}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.parent_id || ""}
                                invalid={ validation.errors.parent_id ? true : false}
                              >
                                <option value="">Select Manager</option>
                                {managerList ? managerList.map(item => 
                                    <option key={item.id} value={item.id}>{item.first_name}{item.last_name}</option>
                                ) : null} 
                                {validation.errors.parent_id? (
                                  <FormFeedback type="invalid">{validation.errors.parent_id}</FormFeedback>
                                ):null}
                              </Input>

                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="phone-field"
                                className="form-label"
                              >
                                phone
                              </Label>
                              <Input
                                name="phone"
                                id="phone-field"
                                className="form-control"
                                placeholder="Enter phone"
                                type="text" 
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.phone || ""}
                                invalid={ validation.errors.phone ? true : false
                                }
                              />
                              {validation.errors.phone ? (
                                <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="email-field"
                                className="form-label"
                              >
                                 Email
                              </Label>
                              <Input
                                name="email"
                                id="email-field"
                                className="form-control"
                                placeholder="Enter Contact email"
                                type="text"
                                readOnly={isInfo}
                                disabled={isInfo}
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={ validation.errors.email ? true : false
                                }
                              />
                              {validation.errors.email ? (
                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                              ) : null}
                            </div>
                          </Col> 
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="country-field"
                                className="form-label"
                              >
                                Country
                              </Label>
                              <Select 
                                  id="country-field"
                                  value={{ value: selectedAddressCountry, label: selectedAddressCountry }}
                                  onChange={(e) => {
                                  handleSelectAddressCountry(e.value);
                                  }} 
                                  isDisabled={isInfo}
                                  options={productCountry}
                                  name="country"
                                  classNamePrefix="select2-selection form-select"
                              />   
                            </div>
                          </Col>

                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="state-field"
                                className="form-label"
                              >
                                State
                              </Label>
                              <Select
                                 id="state-field"
                                  value={{ value: selectedState, label: selectedState }}
                                  onChange={(e) => {
                                  handleSelectState(e.value);
                                  }}  
                                  isDisabled={isInfo}
                                  options={productState}
                                  name="state"
                                  classNamePrefix="select2-selection form-select"
                              />   
                            </div>
                          </Col>

                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="city-field"
                                className="form-label"
                              >
                                City
                              </Label>
                              <Input  className="form-control" 
                                name="city"
                                id="city-field"
                                readOnly={isInfo}
                                disabled={isInfo}
                                placeholder="Enter your city" 
                                value={selectedAddressCity || ""}
                                onChange={(e) => handleSelectAddressCity(e.target.value)} />  
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                          <div className="hstack gap-2 justify-content-end">
                            <Button color="light" onClick={() => { setModal(false); }}> Close </Button>
                            {!isInfo && (
                              <Button type="submit" color="success" id="add-btn"> 
                                {!!isEdit ? "Update" : "Add Employee"}
                              </Button>
                            )}
                          </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                </CardBody>
              </Card>
            </Col> 
          </Row>
              {/* Avatar Modal */}
         {showAvatarModal && (
                        <div className="avatar-modal-overlay">
                            <style>{avatarModalStyles}</style>
                            <div className="avatar-modal">
                                <div className="modal-header">
                                    <h3>Choose an Avatar</h3>
                                    <button 
                                        className="close-btn"
                                        onClick={() => setShowAvatarModal(false)}
                                    >×</button>
                                </div>
                                <AvatarSelector 
                                    onSelect={handleAvatarSelect}
                                    onClose={() => setShowAvatarModal(false)}
                                />
                            </div>
                        </div>
                    )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Employees;
